import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './icon_circle.less'
import Icon, { ICON_SIZES, STROKE_COLORS } from '../icon'

class IconCircle extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    iconSize: PropTypes.oneOf(Object.keys(ICON_SIZES)),
    strokeColor: PropTypes.oneOf(STROKE_COLORS),
  }

  render() {
    return (
      <div styleName="icon-circle">
        <Icon {...this.props} />
      </div>
    )
  }
}

export default cssModules(IconCircle, styles)
